/**
 * The channel a row's Delete action uses to reach the page it is drawn on — the
 * same arrangement modelEditDialog.js describes, for the destructive action.
 *
 * BreadTabulatorActionButton is mounted imperatively by the model's column
 * formatter (`new ComponentClass({ propsData, vuetify, store, router })`), so it
 * has no parent in the page's component tree and cannot `$emit` to it. It IS
 * handed the store, so the store is how it asks the page for a dialog.
 *
 * `hostCount` is what lets the same button keep routing to the delete PAGE
 * where nothing is listening (the legacy dev-model Tabulator pages), so this
 * change is additive for them.
 *
 * Deliberately NOT in the vuex-persist module list in store/index.js — a
 * half-open confirmation is not state worth restoring into the next session.
 */
export default {
  state: {
    data: {
      hostCount: 0,
      /**
       * { serviceKey, modelKey, modelId, row } — `row` is the record the button
       * was drawn on, so the dialog can name it without a second read.
       * Consumed and cleared by the host.
       */
      request: null,
    },
  },
  getters: {
    //
  },
  actions: {
    registerModelDeleteDialogHost(context) {
      context.commit("registerModelDeleteDialogHost");
    },
    unregisterModelDeleteDialogHost(context) {
      context.commit("unregisterModelDeleteDialogHost");
    },
    requestModelDelete(context, data) {
      context.commit("requestModelDelete", data);
    },
    clearModelDeleteRequest(context) {
      context.commit("clearModelDeleteRequest");
    },
  },
  mutations: {
    registerModelDeleteDialogHost(state) {
      state.data.hostCount += 1;
    },
    unregisterModelDeleteDialogHost(state) {
      state.data.hostCount = Math.max(0, state.data.hostCount - 1);
    },
    requestModelDelete(state, data) {
      state.data.request = {
        serviceKey: data.serviceKey,
        modelKey: data.modelKey,
        modelId: data.modelId,
        row: data.row || null,
      };
    },
    clearModelDeleteRequest(state) {
      state.data.request = null;
    },
  },
};
